"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetTypeEnum = {
    initial: 'INITIAL',
    clean: 'CLEAN',
    noreset: '',
};



// WEBPACK FOOTER //
// ./src/dist/commonjs/helpers/enum.js